  <!-- Question -->
<section>
    <div class="uscb-layout-row uscb-bg-primary uscb-color-white">
        @if (!isAnswered()) {
        <span class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-8">Go Paperless</span>
        }
        @if (isAnswered()) {
        <span class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-8">Selection Saved</span>
        }
    </div>

    <mat-dialog-content class="uscb-margin-0">
        <div class="my-dialog-content">
            @if (!isAnswered()) {
            <p class="mat-body-1 uscb-font-lg uscb-margin-0 uscb-text-align-center">
                <b>Would you prefer to go paperless?</b>
                <br/>
                Future reminders and notifications for the {{notificationOptDialogData.surveyName}} will be by email and phone.
            </p>
            }
            @if (isAnswered()) {
            <p class="mat-body-1 uscb-font-1x uscb-margin-0 uscb-text-align-center">
                {{currentConfirmationMessage()}}
                @if (currentActionMessage()) {
                <ng-container>
                    <br/>
                    {{currentActionMessage()}}
                </ng-container>
                }
            </p>
            }
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="uscb-layout-row uscb-layout-align-center-center">
        @if (!isAnswered()) {
        <ng-container>
            <button class="uscb-primary-button" (click)="confirm()" (keyup.enter)="confirm()" tabindex="0">{{notificationOptDialogData.confirmButtonLabel}}</button>
            <div class="uscb-margin-LR-10"></div>
            <button class="uscb-secondary-button" (click)="cancel()" (keyup.enter)="cancel()" tabindex="0">{{notificationOptDialogData.cancelButtonLabel}}</button>
        </ng-container>
        }
        @if (isAnswered()) {
        <ng-container>
            <button class="uscb-primary-button" (click)="close(true)" (keyup.enter)="close(true)" tabindex="0">OK</button>
        </ng-container>
        }
    </mat-dialog-actions>
</section>